import { getUserTypePreference } from '../../util/dataExtractors';
import { UserTypePreference } from '../../util/enums';
import {
  TX_TRANSITION_ACTOR_CUSTOMER,
  TX_TRANSITION_ACTOR_PROVIDER,
} from '../../transactions/transaction';

/**
 * The orders/sales route segment is retained for backwards-compatible URLs, but
 * single-role accounts should always query the side they actually participate on.
 */
export const getMessagesParticipantRole = (tab, currentUser) => {
  const userType = getUserTypePreference(currentUser);

  if (userType === UserTypePreference.PRIVATE_CHEFS) {
    return TX_TRANSITION_ACTOR_PROVIDER;
  }
  if (userType === UserTypePreference.CUSTOMER) {
    return TX_TRANSITION_ACTOR_CUSTOMER;
  }

  return tab === 'sales' ? TX_TRANSITION_ACTOR_PROVIDER : TX_TRANSITION_ACTOR_CUSTOMER;
};

export const getMessagesOnlyFilter = participantRole =>
  participantRole === TX_TRANSITION_ACTOR_PROVIDER ? 'sale' : 'order';

/**
 * Relationship IDs are authoritative once transactions have been loaded. This
 * also keeps legacy or dual-role users on the correct side of each conversation.
 */
export const getTransactionParticipantRole = (transaction, currentUser, fallbackRole) => {
  const currentUserId = currentUser?.id?.uuid;

  if (currentUserId && transaction?.provider?.id?.uuid === currentUserId) {
    return TX_TRANSITION_ACTOR_PROVIDER;
  }
  if (currentUserId && transaction?.customer?.id?.uuid === currentUserId) {
    return TX_TRANSITION_ACTOR_CUSTOMER;
  }

  return fallbackRole;
};
